import { global } from '../global';
import { paths, pathnames } from '../../paths';

export const about = {
  global,
  path: paths.about,
  pathname: pathnames[paths.about],
};
